module.exports = __webpack_public_path__ + "static/media/seguros-mundial-survey-headset.2d30b603.svg";